export const IDENTITY_STORAGE = 'IDENTITY_STORAGE';
